import script from "./CoiIntegrations.vue?vue&type=script&setup=true&lang=js"
export * from "./CoiIntegrations.vue?vue&type=script&setup=true&lang=js"

import "./CoiIntegrations.vue?vue&type=style&index=0&id=399953c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-399953c3"]])

export default __exports__